import { computed, createApp } from 'vue';

import '../shared/init.ts';
import { useRequestBase } from '../shared/composables/request.ts';
import { providePublicFlowAdapter } from '../shared/publicFlows/adapter.ts';
import App from './App.vue';
import createPublicRouter, { PublicContext } from './router.ts';

const element = document.querySelector<HTMLElement>('#public-app');
const contextElement = document.querySelector<HTMLScriptElement>('#public-context');

if (element && contextElement) {
    const context = JSON.parse(contextElement.textContent || '{}') as PublicContext & {
        actorEmail?: string;
        brandUrl: string;
    };
    const router = createPublicRouter(context);
    const app = createApp(App, { brandUrl: context.brandUrl });

    providePublicFlowAdapter({
        actorEmail: computed(() => context.actorEmail),
        apiUrl: '/api',
        baseUrl: window.location.origin,
        brandUrl: context.brandUrl,
        navigate(path) {
            window.location.assign(path);
        },
        back(fallback) {
            window.location.assign(fallback);
        },
        open(url) {
            window.location.assign(url);
        },
        logout() {
            useRequestBase('/logout', {
                headers: { accept: 'application/json' },
            })
                .post()
                .onFetchResponse(() => window.location.reload());
        },
    });

    app.use(router);
    app.mount(element);
}
